module.exports = __webpack_public_path__ + "img/Data-Label-Icon.c5f3fac2.svg";